import React, { Component } from 'react';
import { GenericEditPanel, GenericInputValidate } from 'com-gyf-webcore-userinterfacecomponents';

class DenominacionEmpresa extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeInput = this.changeInput.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} event
     */
    changeInput(event) {
        this.props.changeInput(0, this.props.codigoNovedad, event.target.value);
    }
    /**
     * 
     */
    render() {
        let props = this.props;
        let me = this;
        let errors;
        const { getFieldProps, getFieldError } = this.props.form;
        let errorContainer;

        errorContainer = <label className="error">
            {(errors = getFieldError('inputDenominacionEmpresa')) ? errors.join(',') : null}</label>

        let error = ((getFieldError('inputDenominacionEmpresa')) ? true : false);

        //////////Novedad en Denominacion Empresa////////////
        let seEstaEditando = props.data.seEstaEditando;
        let Denominacion = undefined;
        let novedadDenominacionEmpresa = undefined;
        if (props.data.novedadesEmpresaDatos != undefined) {
            novedadDenominacionEmpresa = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == this.props.codigoNovedad);
            if (novedadDenominacionEmpresa != undefined) {
                let esNovedadEditadaDenominacion = props.data.esNovedadEditada.find(x => x.campoCodigo == this.props.codigoNovedad).editado;
                if (esNovedadEditadaDenominacion) {
                    Denominacion = props.data.empresaDatos.Denominacion;
                }
                else {
                    Denominacion = novedadDenominacionEmpresa.ValorNovedad;
                }
            }
            else {
                Denominacion = props.data.empresaDatos.Denominacion;
            }
        } else {
            Denominacion = props.data.empresaDatos.Denominacion;
        }
        ////////////////////////////////////////////////////
        let componenteDenominacionEmpresa = <div>
            <GenericInputValidate
                getFieldProps={getFieldProps('inputDenominacionEmpresa', {
                    onChange(e) {
                        me.changeInput(e);
                    },
                    rules: [{
                        required: true,
                        message: 'Debe ingresar una denominación.'
                    }]
                })}
                id="inputDenominacionEmpresa"
                name="inputDenominacionEmpresa"
                value={Denominacion}
                className="form-control default-input"
                maxLength="100"
                autoComplete="off"
            />
            {errorContainer}
        </div>

        return (
            <GenericEditPanel
                componente={componenteDenominacionEmpresa}
                error={error}
                permisoUsuario={props.data.funcionesDelUsuario}
                novedad={novedadDenominacionEmpresa}
                seEstaEditando={seEstaEditando}
                textPanel={Denominacion || "Sin especificar"}
                title="Denominación de la empresa (para los archivos)"
                value={Denominacion}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedadDenominacionEmpresa, 2, props.data.empresaDatos.Id)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedadDenominacionEmpresa, 3, props.data.empresaDatos.Id)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar}
            />
        );
    }
}

export default DenominacionEmpresa;